import { useSEO } from "@/hooks/useSEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { siteInfo, testimonials } from "@/mocks/comics";

const aboutSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  name: "关于韩漫屋 - 免费在线漫画阅读平台",
  description: siteInfo.description,
  url: "https://hanmanwu.com/about",
  about: {
    "@type": "Organization",
    name: "韩漫屋",
    description: siteInfo.description,
    foundingDate: "2020",
  },
};

export default function AboutPage() {
  useSEO({
    title: "关于我们 - 韩漫屋 | 免费在线韩国漫画阅读平台",
    description: "韩漫屋成立于2020年，是一个专业的免费在线漫画阅读平台。我们致力于为漫画爱好者提供优质的韩国漫画资源，涵盖恋爱、奇幻、动作、悬疑等多种类型。",
    keywords: "关于韩漫屋,韩漫屋介绍,免费漫画平台,韩国漫画网站,漫画阅读平台",
    canonicalUrl: "https://hanmanwu.com/about",
    ogTitle: "关于我们 - 韩漫屋 | 免费在线韩国漫画阅读平台",
    ogDescription: "韩漫屋是专业的免费在线漫画阅读平台，致力于为漫画爱好者提供优质的韩国漫画资源。",
    ogUrl: "https://hanmanwu.com/about",
    ogType: "website",
    twitterCard: "summary_large_image",
    schemaObjects: [aboutSchema],
  });

  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <Breadcrumb
            items={[
              { label: "首页", href: "/" },
              { label: "关于我们" },
            ]}
          />

          <section className="py-10 md:py-16">
            <div className="text-center mb-12">
              <h1 className="text-3xl md:text-4xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                关于韩漫屋
              </h1>
              <p className="text-sm text-foreground-600 mt-4 max-w-2xl mx-auto leading-relaxed">
                韩漫屋成立于2020年，是一个专业的<strong>免费在线漫画阅读平台</strong>。我们致力于为漫画爱好者提供优质的<strong>韩国漫画</strong>资源，汇集了<strong>精彩韩漫大全</strong>，涵盖多种类型，是您探索韩漫的理想起点。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
              <div className="p-8 rounded-lg bg-background-100 border border-background-200/70 text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-book-open-line text-2xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-950 mt-5">海量资源</h3>
                <p className="text-sm text-foreground-600 mt-2 leading-relaxed">拥有超过5000部韩国漫画作品，涵盖恋爱、奇幻、动作、悬疑等八大分类，满足不同读者的阅读偏好。</p>
              </div>
              <div className="p-8 rounded-lg bg-background-100 border border-background-200/70 text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-shield-check-line text-2xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-950 mt-5">高清画质</h3>
                <p className="text-sm text-foreground-600 mt-2 leading-relaxed">所有漫画均经过精心优化，确保在各类设备上呈现出色的阅读体验，细节清晰、色彩出众。</p>
              </div>
              <div className="p-8 rounded-lg bg-background-100 border border-background-200/70 text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                  <i className="ri-flashlight-line text-2xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-950 mt-5">极速更新</h3>
                <p className="text-sm text-foreground-600 mt-2 leading-relaxed">编辑团队每日更新，热门连载作品保持每周稳定更新，让您追更不等待，精彩不间断。</p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center mb-16">
              <div className="flex-1">
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                  我们的使命
                </h2>
                <p className="text-sm text-foreground-700 mt-4 leading-relaxed">
                  我们相信，优秀的漫画作品应该触手可及。韩漫屋以「让每个人都能轻松享受韩漫」为使命，持续收录国内外优质韩国漫画资源，打造一个完全免费、纯净无广告的漫画阅读空间。
                </p>
                <p className="text-sm text-foreground-700 mt-3 leading-relaxed">
                  作为一个专业的<strong>免费在线漫画</strong>平台，我们始终保持对内容的敬畏与热情。每一部漫画都经过精心筛选和优化处理，确保读者能够获得最佳的阅读体验。无论您是韩漫新人还是资深读者，韩漫屋都将是您探索<strong>精彩韩漫大全</strong>的最佳选择。
                </p>
              </div>
              <div className="flex-shrink-0 w-full md:w-96">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20cozy%20reading%20nook%20with%20a%20digital%20tablet%20displaying%20colorful%20webtoon%20art%2C%20soft%20ambient%20lighting%2C%20bookshelf%20background%2C%20minimalist%20Korean%20interior%20style%2C%20warm%20cream%20and%20wood%20tones%2C%20peaceful%20atmosphere%2C%20clean%20composition&width=600&height=400&seq=about-mission&orientation=landscape"
                  alt="韩漫屋使命 - 舒适的漫画阅读体验"
                  className="w-full rounded-lg"
                />
              </div>
            </div>

            <div className="mb-16">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                读者口碑
              </h2>
              <p className="text-sm text-foreground-600 text-center mb-10">来自真实读者的评价与反馈</p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {testimonials.map((t) => (
                  <div key={t.id} className="p-6 rounded-lg bg-background-100 border border-background-200/70">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: t.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 w-4 h-4 flex items-center justify-center text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed">{t.comment}</p>
                    <div className="flex items-center gap-3 mt-4 pt-4 border-t border-background-200/70">
                      <img
                        src={t.avatar}
                        alt={t.name}
                        className="w-10 h-10 rounded-full object-cover"
                      />
                      <span className="text-sm font-semibold text-foreground-950">{t.name}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-16">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                联系我们
              </h2>
              <p className="text-sm text-foreground-600 text-center mb-10">欢迎通过以下方式与我们取得联系</p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="p-6 rounded-lg bg-background-100 border border-background-200/70 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className="ri-mail-line text-xl"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mt-4">电子邮箱</h3>
                  <p className="text-sm text-foreground-600 mt-1">{siteInfo.email}</p>
                </div>
                <div className="p-6 rounded-lg bg-background-100 border border-background-200/70 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-wechat-line text-xl"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mt-4">微信公众号</h3>
                  <p className="text-sm text-foreground-600 mt-1">{siteInfo.wechat}</p>
                </div>
                <div className="p-6 rounded-lg bg-background-100 border border-background-200/70 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                    <i className="ri-qq-line text-xl"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mt-4">QQ群</h3>
                  <p className="text-sm text-foreground-600 mt-1">{siteInfo.qq}</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}